import { Route, Routes } from 'react-router-dom'
import ImportedGoodLiabilityOverviewPdf from './ImportedGoodLiabilityOverviewPdf'
import SimulationGoodLiabilityOverviewPdf from './SimulationGoodLiabilityOverviewPdf'

/**
 * Routes mounted by the SPA when the path starts with /liability-overview-pdf.
 * Each page loads the same data as the in-app overview dialog and renders
 * `LiabilityOverviewTemplate` for server-side PDF capture.
 */
export default function LiabilityOverviewPdfRoutes() {
  return (
    <Routes>
      <Route path="imported/:importedGoodId" element={<ImportedGoodLiabilityOverviewPdf />} />
      <Route path="simulation/:simulationGoodId" element={<SimulationGoodLiabilityOverviewPdf />} />
    </Routes>
  )
}
